import { api, unwrap } from './client';

export async function listSubscriptions() {
  const res = await api.get('/finance/subscriptions');
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function listSubscriptionsByCustomer(customerId) {
  const res = await api.get(`/finance/subscriptions/customer/${customerId}`);
  const d = unwrap(res);
  return Array.isArray(d) ? d : (d?.content || []);
}

export async function getSubscription(id) {
  const res = await api.get(`/finance/subscriptions/${id}`);
  return unwrap(res);
}

export async function createSubscription(payload) {
  const res = await api.post('/finance/subscriptions', payload);
  return unwrap(res);
}

export async function updateSubscriptionStatus(id, status) {
  const res = await api.put(
    `/finance/subscriptions/${id}/status?status=${encodeURIComponent(status)}`,
  );
  return unwrap(res);
}
